import { importWithRetry } from '@shared/core/chunkRetry';

/**
 * Loads a Google font family through webfontloader, which is fetched on demand.
 * Callers in effects ignore the returned promise, so a final chunk failure stays an
 * unhandled rejection as it was before the retry was added.
 */
export const loadWebFont = (family: string): Promise<void> =>
  importWithRetry(() => import('webfontloader'), 'webfontloader').then(WebFont => {
    WebFont?.load({
      google: {
        families: [family],
      },
    });
  });
